import './index.css';

export default {
  name: 'Abreadcrumb',
  props: {
    data: {
      type: Array,
      default: () => [
        { text: '首页', path: '/' },
        { text: '模块', path: '' },
        { text: '分页', path: '' },
      ],
    },
    items: { type: Array, default: () => null },
    config: { type: Array, default: () => null },
    option: { type: Array, default: () => null },
    options: { type: Array, default: () => null },
    separator: { type: String, default: () => '/' },
  },
  render() {
    const { ...attrs } = this.$attrs;
    const data = this.options || this.option || this.config || this.items || this.data || [];
    return (
      <div class="a-breadcrumb">
        <el-breadcrumb separator={this.separator} {...{ attrs }}>
          {data.length > 0 && data.map((a, b) => {
            return (
              <el-breadcrumb-item key={b}>
                <div class="item">
                  {a.rander ? () => a.rander() : (a.title || a.label || a.text || a.name || `${a}`)}
                </div>
              </el-breadcrumb-item>
            )
          })}
        </el-breadcrumb>
      </div>
    );
  }
}